import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FAQ_CATEGORIES, FAQ_ITEM_DEFS, faqItemCountByCategory } from '../../data/faqData';
import './FaqCategoryIndex.css';

export function FaqCategoryIndex() {
  const { t } = useTranslation();
  const counts = faqItemCountByCategory();
  const topics = FAQ_CATEGORIES.filter((c) => c.id !== 'all');

  return (
    <nav className="saas-faq-index" aria-labelledby="saas-faq-index-title">
      <h2 id="saas-faq-index-title" className="saas-faq-index__title">
        {t('faq.indexTitle')}
      </h2>
      <p className="saas-faq-index__sub">{t('faq.indexSub', { count: FAQ_ITEM_DEFS.length })}</p>
      <ul className="saas-faq-index__list">
        <li>
          <Link to="/faq" className="saas-faq-index__pill saas-faq-index__pill--all">
            <span className="saas-faq-index__icon" aria-hidden="true">
              ✦
            </span>
            <span className="saas-faq-index__label">{t('faq.categories.all')}</span>
            <span
              className="saas-faq-index__count"
              aria-label={t('faq.indexCountAria', { count: FAQ_ITEM_DEFS.length })}
            >
              {FAQ_ITEM_DEFS.length}
            </span>
          </Link>
        </li>
        {topics.map((c) => (
          <li key={c.id}>
            <Link to={`/faq?cat=${encodeURIComponent(c.id)}`} className="saas-faq-index__pill">
              <span className="saas-faq-index__icon" aria-hidden="true">
                {c.icon}
              </span>
              <span className="saas-faq-index__label">
                {t(`faq.categories.${c.id}`, { defaultValue: c.label })}
              </span>
              <span className="saas-faq-index__count" aria-label={t('faq.indexCountAria', { count: counts[c.id] ?? 0 })}>
                {counts[c.id] ?? 0}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
